module.exports = __webpack_public_path__ + "static/media/bz.e7e7013d.svg";